function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M-22 1080.19C41.6175 1017.12 223.486 891.183 442.018 892.008C660.55 892.832 706 704.5 680.886 518.475C635.94 185.545 413.307 -78 -22 22.5006M-20.7633 730.051C138.486 792.604 375.874 703.289 413.219 518.475C455.483 309.322 270.626 -14.2996 -20.7633 186.5M413.307 1293C450.926 1159.96 592.114 898.81 855.914 918.538C1119.71 938.267 1241 664.5 1259.19 516C1277.01 370.484 1377.68 73.2 1462 56M1462 509.5C1463.8 614.733 1407.17 720.167 1339.57 799.927C1235.91 922.24 1019.18 948.036 956.148 1099.69C925.481 1173.47 951.343 1241.99 989.259 1293M1271.55 1293C1289.59 1211.15 1352.92 1032.72 1462 973.787",
  stroke: "url(#paint0_linear_7660_141599)",
  strokeWidth: 0.5
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_7660_141599",
  x1: 1462.04,
  y1: 646.923,
  x2: -22,
  y2: 646.923,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})));

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1294,
    viewBox: "0 0 1440 1294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.1eb0b816385ddb122a881be4f8ae7f18.svg";
export { ForwardRef as ReactComponent };